import { useState, useEffect } from 'react';
import { SwitchInputProps } from './Types';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import InputLabel from './InputLabel';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const SwitchInput = ({
  label,
  onChange,
  name,
  required = false,
  value = false,
  placeholder = '',
  loading = false,
  checkColor = 'primary',
  unCheckColor = 'gray-500',
  stopPropogation = false,
}: SwitchInputProps) => {
  return (
    <div className="flex flex-row justify-between align-middle space-s-2 items-center">
      <div className="flex-grow flex-col">
        {label && <InputLabel text={label} name={name} required={required} />}
        <div className="text-textSecondary text-xs text-start">
          <ReturnTranslatedText
            origintext={placeholder}
            text={`inputs.placeholders.${placeholder}`}
          />{' '}
        </div>
      </div>

      <div
        onClick={(e) => {
          if (stopPropogation) {
            e.stopPropagation();
          }

          onChange(name, !value);
        }}
        className="relative input inline-block w-10 my-auto  me-2 align-middle select-none transition duration-200 ease-in h-full"
      >
        <span
          className={`${
            value ? `border-green-500 ltr:right-0 rtl:left-0` : `border-red-500`
          } absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer flex items-center justify-center`}
        >
          {loading && (
            <AiOutlineLoading3Quarters className="animate-spin text-primary" />
          )}
        </span>
        <label
          className={`block overflow-hidden h-6 rounded-full ${
            value ? ` bg-green-500` : `bg-red-500`
          } cursor-pointer`}
        ></label>
      </div>
    </div>
  );
};

export default SwitchInput;
